/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const AuxConnect = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 23 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M21.11 11.62a4 4 0 0 0-5.67 0l-9 9a2.828 2.828 0 1 1-4-4l1.81-1.8 2-2c.327.302.755.47 1.2.47.48 0 .94-.19 1.28-.53l.95-.95 6-6a.61.61 0 0 0 0-.85l-.78-.78L18.1 1a.61.61 0 0 0 0-.85.59.59 0 0 0-.85 0l-3.19 3.22-.78-.78a.59.59 0 0 0-.85 0l-6 6-1 1a1.79 1.79 0 0 0-.53 1.27c.021.425.191.828.48 1.14l-2 2-1.8 1.84a4.01 4.01 0 1 0 5.67 5.67l9-9a2.828 2.828 0 1 1 4 4l-7.83 7.84a.61.61 0 0 0 .42 1 .6.6 0 0 0 .43-.18l7.83-7.83a4 4 0 0 0 .01-5.72z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

AuxConnect.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

AuxConnect.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default AuxConnect;
